import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	settingsMenuItem: {
		padding: "15px"
	}
}))

export default useStyles
